import React, { FC, useContext } from 'react';
import Job from '../../jobs/types/job';
import { StateContext } from '../../state/contexts';

export type OverlayJobListProperties = {
  className?: string;
  itemClassName?: string;
  jobsAtMarkerLocation: Job[];
  markerKey: string;
  Item: React.ComponentType<OverlayJobListItemProperties>;
};

const OverlayJobList: FC<OverlayJobListProperties> = ({
  className = 'list-group list-group-flush',
  itemClassName = 'list-group-item',
  jobsAtMarkerLocation,
  markerKey,
  Item,
}) => (
  <ul className={className}>
    {jobsAtMarkerLocation.map((job) => (
      <li className={itemClassName} key={`${markerKey}_${job.id}`}>
        <Item job={job} markerKey={markerKey} />
      </li>
    ))}
  </ul>
);

export type OverlayJobListItemProperties = { job: Job; markerKey: string };

export const OverlayJobListItem: FC<OverlayJobListItemProperties> = ({ job, markerKey }) => {
  const state = useContext(StateContext);
  const { config } = state;
  const { linkTarget } = config.config.ui;

  return (
    <div>
      <a
        className="dvinci-job-position"
        href={job.jobPublicationURL || job.applicationFormURL}
        target={linkTarget}
        rel={linkTarget === '_blank' ? 'noopener' : 'noreferrer'}
      >
        {job.position}
      </a>

      {job.subtitle && <div className="dvinci-job-subtitle text-muted mb-sm-1">{job.subtitle}</div>}

      <ul className="dvinci-job-categories-list list-inline">
        {job.jobOpening.categories
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((category) => (
            <li key={`${markerKey}_${job.id}_}${category.id}`}>
              <small>{category.name}</small>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default OverlayJobList;
